

import React from "react";
import { Link } from "react-router-dom";
import "../styles/cta.css";

function CTA() {
  return (
    <section className="cta">
      <div className="cta-overlay">
        <div className="container cta-content">
          <h2>Looking for Reliable Industrial Supplies?</h2>

          <p>
            Get in touch with us today to discuss your industrial product
            requirements and receive expert support.
          </p>

          <div className="cta-actions">
            <Link to="/contact" className="btn btn-primary">
              Send an Inquiry
            </Link>

            <a href="tel:+971585735792" className="btn btn-outline-light">
              Call Us Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;
